var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('bouncing-component')],1):_c('div',[(_vm.reports.length > 0)?_c('render-index-table',{attrs:{"reports":_vm.reports}}):_c('div',{staticClass:"text-center"},[_c('em',[_vm._v("There isn't a report using this query")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }